module.exports = __webpack_public_path__ + "static/media/insect(27).cbb3ed42.PNG";